module.exports = __webpack_public_path__ + "img/hr-tree-01-c-leaves.a5003018.png";